module.exports = __webpack_public_path__ + "static/media/MTL_ASC_MED1.cd0f752f.png";